import { useState } from 'react';
import { create } from 'zustand';

import { useRosService } from 'hooks/ros';

import { logGreen } from 'utils/debugger';

// const useArmLockedStore2 = create((set) => ({
//   armLocked: false,
//   // note - always do this because that way each setter is not trigger rerendering
//   actions: {
//     lockArm: () => set({ armLocked: true }),
//     unlockArm: () => set({ armLocked: false }),
//   },
// }));
//
// function useArmLockedActions() {
//   return useArmLockedStore2((s) => s.actions);
// }
//
// function useArmLocked() {
//   return useArmLockedStore2((s) => s.actions);
// }

// note: zustand don't look good handling primitives
const useArmLockStore = create<boolean>(() => false);

/**
 * does not subscribe to state update so no re-render
 * TODO: Validate that triggering this with the same value does not cause a re-render
 * TODO: https://tkdodo.eu/blog/working-with-zustand read this any maybe improve this
 */
export function useSetArmLocked() {
  function setArmLock(value: boolean) {
    useArmLockStore.setState(value);
  }

  /**
   * Every arm interaction has to reset the lock
   */
  function setArmUnlock() {
    useArmLockStore.setState(false);
  }

  return { setArmLock, setArmUnlock };
}

function useArmLocked(): [boolean, (value: boolean) => void] {
  const armLocked = useArmLockStore();
  const { setArmLock } = useSetArmLocked();

  return [armLocked, setArmLock];
}

/**
 * The arm can be locked (to world) and also can be unlocked (to body). Every interaction will reset the lock.
 *
 * Lock the arm means its locked to the world. That means the arm will not move when the robot moves.
 * The default is locked to the body which means when body moves the arm moves with it.
 *
 * Todo: Zustand in the current usage is not ready for being a proper solution for us.
 * Maybe something like this helps: https://pietrobondioli.com.br/articles/how-to-clear-all-zustand-stores-at-once
 * Or we wrap everything with that? https://zustand.docs.pmnd.rs/guides/how-to-reset-state
 */
export function useLockArm() {
  const [loading, setLoading] = useState(false);
  const { RosServices } = useRosService();
  const [armLocked, setArmLock] = useArmLocked();

  async function lockArm() {
    setLoading(true);
    logGreen('Locking arm to body');
    await RosServices.armLockWorld().finally(() => setLoading(false));

    setArmLock(true);
  }

  async function unlockArm() {
    setLoading(true);
    logGreen('Locking arm to body');
    await RosServices.armLockBody().finally(() => setLoading(false));
    setArmLock(false);
  }

  return { loading, armLocked, lockArm, unlockArm };
}
